export default "__VITE_ASSET__BRenlcJr__"